import React, { ReactNode, useState } from 'react';
import { TemplatePanel as Panel } from '@cvent/carina/components/Templates/TemplatePanel';
import { Header } from '@cvent/carina/components/Templates/Header';
import { Body } from '@cvent/carina/components/Templates/Body';
import { Main } from '@cvent/carina/components/Templates/Main';
import { ContentArea } from '@cvent/carina/components/Templates/ContentArea';
import { Page as TemplatePage } from '@cvent/carina/components/Templates/Page';
import { useNavigation } from '@cvent/carina/components/Navigation/NavigationProvider';
import { ThemeProvider } from '@cvent/carina/components/ThemeProvider/ThemeProvider';
import { ThemeProvider as V0ThemeProvider } from '@cvent/carina-theme-provider';
import { getDefaultTheme } from '@cvent/carina/utils/tokens';
import { SelectedThemeProvider } from 'src/hooks/use-selected-theme';
import AppProviders from './AppProviders';
import { SideNavigation } from './SideNavigation';
import { TopNavigation } from './TopNavigation';

export function BasePage({ children }: { children: ReactNode }): JSX.Element {
  const [isLocalNavOpen, setLocalNavOpen] = useState(true);
  const { localNav } = useNavigation();

  return (
    <ThemeProvider theme={getDefaultTheme()}>
      <V0ThemeProvider theme={getDefaultTheme()}>
        <SelectedThemeProvider value="default">
          <AppProviders>
            <TemplatePage>
              <Main as="div">
                <Header>
                  <TopNavigation
                    hasLocalNav={localNav.length > 0}
                    toggleNav={(): void => setLocalNavOpen(curr => !curr)}
                    isLocalNavOpen={isLocalNavOpen}
                  />
                </Header>
                <Body>
                  {localNav.length > 0 && isLocalNavOpen && (
                    <Panel>
                      <SideNavigation isOpen={isLocalNavOpen} />
                    </Panel>
                  )}
                  <ContentArea>
                    <div
                      css={{
                        flexGrow: 1,
                        overflowY: 'auto'
                      }}
                    >
                      {children}
                    </div>
                  </ContentArea>
                </Body>
              </Main>
            </TemplatePage>
          </AppProviders>
        </SelectedThemeProvider>
      </V0ThemeProvider>
    </ThemeProvider>
  );
}
